import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input"]
    triggerFileInput(event) {
        this.inputTarget.click()
    }

    preview(event) {
        const input = event.target
        const file = input.files[0]

        if (file) {
            const reader = new FileReader()
            reader.onload = (e) => {
                const preview = this.element.closest('form').querySelector('img')
                if (preview) {
                    preview.src = e.target.result
                } else {
                    const container = this.element.closest('form').querySelector('.bg-gray-200')
                    const newPreview = document.createElement('img')
                    newPreview.classList.add('w-32', 'h-32', 'rounded-full', 'object-cover', 'mb-2')
                    newPreview.src = e.target.result
                    container.replaceWith(newPreview)
                }
            }
            reader.readAsDataURL(file)
        }
    }
} 